import styled, { css } from 'styled-components';
import { Typography } from '../../../global/theme';
import { mobile_xl } from '../../../global/mediaQueryMixin';
import { AlignCenter } from '../../../global/commonStyle';

export const Box = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  align-items: center;
  padding: var(--space-20);
  gap: var(--space-12);
  background: var(--background-primary);
  border: 0.5px solid var(--border-primary);
  box-shadow: var(--shadow-card);
  border-radius: var(--border-radius-12);
  ${mobile_xl(css`
    grid-template-columns: repeat(1, 1fr);
  `)}
`;

// section div
export const SectionDiv = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: var(--space-6);
  align-items: flex-start;
`;

// title
export const Title = styled.p`
  margin-block: var(--space-0);
  ${Typography.body_md_medium}
  color: var(--text-primary);
  span {
    ${Typography.body_md}
    color: var(--text-secondary);
  }
`;

// bottom section
export const BottomSection = styled.div`
  width: 100%;
  ${AlignCenter}
  gap: var(--space-8);
`;
